<mat-checkbox [checked]="checkedSubject | async" color="primary" #checkbox>
    {{(actorAuthDefSubject | async).display | translate}}
</mat-checkbox>

<ss-dynamic-form 
    #form
    *ngIf="(actorAuthDefSubject | async).controls"
    class="actor-auth-form"
    [ngStyle]="{
        display:(showFormObs | async) ? 'inline' : 'none'
    }" 
    [controls]="(actorAuthDefSubject | async).controls"
>
</ss-dynamic-form>
